import React from 'react';
import { $getNotice, $getAlarmFlag, $toggleAlarm } from '@/_api_/noticeAPI';
import types from '@/actions/noticeTypes';
import { toast } from 'react-toastify';

export const _getNotice = () => async (dispatch) => {
  const response = await $getNotice();
  let noticeList = response.data;
  if (noticeList.length < 1) {
    delete localStorage.checkNoticeList;
    return;
  }
  if (localStorage.checkNoticeList) {
    noticeList = response.data.filter((data)=>(
      localStorage.checkNoticeList.split(",").findIndex((el)=>(el === data.id)) < 0
    ))
  }
  let ids = [];
  noticeList.forEach((notice)=>{
    ids.push(notice.id)
  })
  if (noticeList.length < 1) {
    return;
  }
  toast.info(
    <div>
      {noticeList.map((notice,index)=>(
          <div key={index}>
            <h5>{notice.title.indexOf('</') !== -1 ? (
                  // eslint-disable-next-line
                  <div dangerouslySetInnerHTML={{__html: notice.title.replace(/(<? *script)/gi, 'illegalscript')}} >
                  </div>
                )
              : notice.title
            }</h5>
            <p>
              {notice.desc.indexOf('</') !== -1 ? (
                  // eslint-disable-next-line
                  <div dangerouslySetInnerHTML={{__html: notice.desc.replace(/(<? *script)/gi, 'illegalscript')}} >
                  </div>
                )
              : notice.desc}
            </p>
          </div>
      ))}
      <div className="text-right">
        <button onClick={() => _checkNotice(ids)} className="btn btn-sm btn-outline-warning">더 이상 보지 않기</button>
      </div>
    </div>, {
      autoClose: false,
      closeOnClick: true
    }
  )
}

export const _checkNotice = (ids) => {
  if (!localStorage.checkNoticeList) {
    localStorage.checkNoticeList = "";
  }
  for (let id of ids) {
    localStorage.checkNoticeList += id + ","
  }
}

export const _getAlarmFlag = () => async (dispatch, getState) => {
  if (!getState().main.empNo) {
    return;
  }
  const response = await $getAlarmFlag(getState().main.empNo);
  dispatch({
    type: types.SET_ALARM_FLAG,
    flag: response.data.flag
  })
}

export const _toggleAlarm = () => async (dispatch, getState) => {
  if (!getState().main.empNo) {
    return;
  }
  const response = await $toggleAlarm(getState().main.empNo);
  dispatch(_getAlarmFlag())
  if (response.data.result) {
    toast.info('Alarm On!')
  } else {
    toast.warning('Alarm Off')
  }
}



// WEBPACK FOOTER //
// ./src/actions/noticeAction.js